import { render, staticRenderFns } from "./point-member-detail.vue?vue&type=template&id=02ef2ab1&scoped=true"
import script from "./point-member-detail.vue?vue&type=script&lang=js"
export * from "./point-member-detail.vue?vue&type=script&lang=js"
import style0 from "./point-member-detail.vue?vue&type=style&index=0&id=02ef2ab1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ef2ab1",
  null
  
)

export default component.exports